import {
  RETRIEVAL_GUARDIAN_BOND,
} from "../guardianFormConfig";
import {
  GoogleAutoComplete,
  LabeledCreatableSelect,
  splitEmploymentOccupation,
  joinEmploymentOccupation,
} from "./TrusteeBondRetrieveShared";
import RetrievalGuardianFormBase from "./RetrievalGuardianFormBase";

export default function TrusteeGuardianForm(props) {
  return (
    <RetrievalGuardianFormBase
      bondKind={RETRIEVAL_GUARDIAN_BOND.trustee}
      GoogleAutoComplete={GoogleAutoComplete}
      LabeledCreatableSelect={LabeledCreatableSelect}
      splitEmploymentOccupation={splitEmploymentOccupation}
      joinEmploymentOccupation={joinEmploymentOccupation}
      {...props}
    />
  );
}
